import React from 'react'
import { Link } from 'react-router-dom'

import Icon from '../../../../components/icon'

export default function ConfirmationView({
  styles,
  t,
  eventTitle,
  formattedLocation,
  totalAch,
  paymentDeadlineStr,
  eventBasePath,
}) {
  return (
    <div style={{ paddingTop: 20 }}>
      <div style={{ textAlign: 'center', padding: '40px 0 28px' }}>
        <div className={styles.confirmCheck}>
          <Icon name="check" />
        </div>
        <div className={styles.confirmTitle}>
          {t('sponsorPledgeFlow.confirm.title')}
        </div>
      </div>

      <div className={styles.confStepper}>
        <div className={`${styles.confStep} ${styles.confStepDone}`}>
          <div className={styles.confStepCircle}>
            <Icon name="check" style={{ fontSize: 11 }} />
          </div>
          <div className={styles.confStepLabel}>
            {t('sponsorPledgeFlow.confirm.stepNext')}
          </div>
        </div>
        <div className={styles.confConnector} />
        <div className={`${styles.confStep} ${styles.confStepDone}`}>
          <div className={styles.confStepCircle}>
            <Icon name="check" style={{ fontSize: 11 }} />
          </div>
          <div className={styles.confStepLabel}>
            {t('sponsorPledgeFlow.confirm.stepPayment')}
          </div>
        </div>
        <div className={styles.confConnector} />
        <div className={styles.confStep}>
          <div className={styles.confStepCircle}>2</div>
          <div className={styles.confStepLabel}>
            {t('sponsorPledgeFlow.confirm.stepEvent')}
          </div>
        </div>
        <div className={styles.confConnector} />
        <div className={styles.confStep}>
          <div className={styles.confStepCircle}>3</div>
          <div className={styles.confStepLabel}>
            {t('sponsorPledgeFlow.confirm.stepStory')}
          </div>
        </div>
      </div>

      <h2 className={styles.stepHeading}>
        {t('sponsorPledgeFlow.confirm.nextHeading')}
      </h2>
      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.confirm.introSubmitted', {
          tier: t('sponsorPledgeFlow.tier.name'),
          event: eventTitle,
          location:
            formattedLocation || t('sponsorPledgeFlow.header.locationTbd'),
        })}
      </p>

      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.confirm.paymentMethodSaved')}
      </p>

      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.confirm.emailSent')}
      </p>

      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.confirm.totalEstimateLine', {
          total: totalAch,
          due: paymentDeadlineStr,
        })}
      </p>

      <h2 className={styles.stepHeading} style={{ marginTop: 24 }}>
        {t('sponsorPledgeFlow.confirm.whatNextHeading')}
      </h2>
      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.confirm.whatNextBody')}
      </p>

      <div className={styles.confirmActions}>
        <div className={styles.confirmActionsLeft}>
          <Link to="/settings" className={styles.btnOutline}>
            <Icon name="bell" /> {t('sponsorPledgeFlow.confirm.notifications')}
          </Link>
          <Link to="/dashboard" className={styles.btnTextLink}>
            <Icon name="chart-line-up" />{' '}
            {t('sponsorPledgeFlow.confirm.dashboard')}
          </Link>
        </div>
        <Link to={eventBasePath} className={styles.btnPrimary}>
          <Icon name="calendar" /> {t('sponsorPledgeFlow.confirm.backToEvent')}
        </Link>
      </div>
    </div>
  )
}
